import React from "react";
import { useSelector } from "react-redux";
import Stage from "./Stage";
import RobotControl from "../../RobotView/RobotControl";

export default function StageRouter(props) {
  const isRobotModeOpen = useSelector((s) => s.scene.robotModeOpen);

  // Conditional rendering OUTSIDE the component with hooks
  if (isRobotModeOpen) {
    return <RobotControl />;
  }

  return <Stage {...props} />;
}
